export default __webpack_public_path__ + "static/media/roles_1.fcee01a5.png";